import { useMemo, useRef, useState } from 'react'
import { useIntl } from 'react-intl'
import PlanMenuMobileHeader from './plan-menu-mobile-header'
import {
  PlanMenuMobileViewContainer,
  SearchContainer
} from '../../styled-component'
import { useGetProjectDetailsQuery } from '../../../../react-query/project/query/use-get-project-details-query'
import { useParams } from 'react-router-dom'
import PlanMenuMobilePlanList from './plan-menu-mobile-plan-list'
import SearchComponent from '../../../../components/stories/molecules/search'
import { Search } from '../../../../components/stories/atoms/icons/menu'
import { searchVariantsOptions } from '../../../../components/stories/molecules/search/constants'
import { debounce } from 'lodash'
import { SEARCH_DEBOUNCE_MS } from '../../constants'

const PlanMenuMobileView = () => {
  const { formatMessage } = useIntl()
  const { projectId } = useParams()
  const containerRef = useRef(null)

  // state
  const [searchValue, setSearchValue] = useState('')
  const [isProjectEmpty, setIsProjectEmpty] = useState(true)

  const debounceSearch = useMemo(
    () => debounce((value) => setSearchValue(value), SEARCH_DEBOUNCE_MS),
    []
  )

  // queries
  const { data: projectDetails, isLoading: projectDetailsLoading } =
    useGetProjectDetailsQuery({ projectId })

  return (
    <PlanMenuMobileViewContainer ref={containerRef}>
      <PlanMenuMobileHeader
        title={projectDetails?.name}
        isLoading={projectDetailsLoading}
      />

      {!isProjectEmpty && (
        <SearchContainer>
          <SearchComponent.Root
            variant={searchVariantsOptions.MOBILE}
            placeholder={formatMessage({ id: 'search' })}
            customOnChange={debounceSearch}
          >
            <SearchComponent.Container>
              <SearchComponent.LeadingIcon icon={Search} />
              <SearchComponent.Input />
              <SearchComponent.ClearButton />
            </SearchComponent.Container>
            <SearchComponent.CancelButton />
          </SearchComponent.Root>
        </SearchContainer>
      )}

      <PlanMenuMobilePlanList
        search={searchValue}
        isLoading={projectDetailsLoading}
        onEmptyStateChange={setIsProjectEmpty}
      />
    </PlanMenuMobileViewContainer>
  )
}

export default PlanMenuMobileView
